import { useShallow } from 'zustand/react/shallow'
import { PauseIcon, PlayIcon } from 'assets/icons'
import Tooltip from 'components/Tooltip'
import { usePlayerStore } from 'store'
import s from '../../index.module.scss'

interface Props {
	videoElement: HTMLMediaElement | null | undefined
}

const PlayPause = ({ videoElement }: Props): JSX.Element => {
	const [playing, setValue] = usePlayerStore(
		useShallow((state) => [state.playing, state.setValue]),
	)
	const onPlay = (): void => {
		if (videoElement) {
			videoElement.play()
			setValue({ playing: true })
		}
	}
	const onPause = (): void => {
		if (videoElement) {
			videoElement.pause()
			setValue({ playing: false })
		}
	}

	return (
		<Tooltip title={playing ? 'APP_PAUSE_CONTROL' : 'APP_PLAY_CONTROL'}>
			<div className={s.control} onClick={playing ? onPause : onPlay}>
				{playing ? <PauseIcon /> : <PlayIcon />}
			</div>
		</Tooltip>
	)
}

export default PlayPause
